import { Toast } from 'common/ToastMessage'
import { Spinner } from 'common/Spinner/Spinner'
import Styles from 'screens/ProseEdit/components/ProcessingSuggestionToast/ProcessingSuggestionToast.module.scss'
import { SuggestionRequestStatus } from 'types'
import { ReactComponent as SuccessIcon } from 'assets/icons/circleCheckMark16.svg'

interface ToastProps {
  copies: number
  total: number
  generatingImages: boolean
  status: SuggestionRequestStatus
}

export const GeneratingPostToast = ({ copies, total, generatingImages, status }: ToastProps) => {
  const totalCopies = copies > total ? copies : total
  const isSuccessful = status === SuggestionRequestStatus.Successful

  let text = 'Generating post'
  if (copies > 0) text = `Generating copy options ${copies}/${totalCopies}.`
  if (generatingImages) text = 'Generating images'
  if (isSuccessful) text = 'Post generated successfully!'

  if (isSuccessful)
    return (
      <Toast.Root variant="success">
        <Toast.Icon variant="success">
          <SuccessIcon />
        </Toast.Icon>
        <Toast.Description>Post generated successfully!</Toast.Description>
      </Toast.Root>
    )

  return (
    <Toast.Root variant="info">
      <Toast.Icon variant="info">
        <Spinner className={Styles.spinner} variant="dark" />
      </Toast.Icon>
      <Toast.Description>{text}</Toast.Description>
    </Toast.Root>
  )
}
